import { Box, useMediaQuery } from "@mui/material";
import React from "react";

import Nav from "../../components/navComponents/Nav";
import Publications from "../../components/Publications";

import { styles } from "./styles";

const PublicationPage = () => {
  const matches = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  return (
    <Box>
      <Nav />
      <Publications />
    </Box>
  );
};

export default PublicationPage;
